import { createContext } from 'react';
import { IAuthenticationContext } from './types';

export default createContext<IAuthenticationContext | undefined>(undefined);
